import { AbEntryType } from '../models/ab-entry';

export function isIndividual(type: string | null | undefined): boolean {
  return type === AbEntryType.Individual;
}

export function isContact(type: string | null | undefined): boolean {
  return type === AbEntryType.Contact;
}

export function isCompany(type: string | null | undefined): boolean {
  return type === AbEntryType.Company;
}
